import Vue from 'vue'
import {
  FrhomoloLogin,
  FrhomoloImageView,
  FrhomoloVideoView,
  FrhomoloRegionSelect,
  FrhomoloImageSynthesis,
  FrhomoloHandWrite
} from '../../packages/index';

Vue.use(FrhomoloLogin);
Vue.use(FrhomoloImageView);
Vue.use(FrhomoloRegionSelect);
Vue.use(FrhomoloImageSynthesis);
Vue.use(FrhomoloHandWrite);
Vue.use(FrhomoloVideoView);
